import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ModalDialogType, ReturnPaymentType } from 'src/app/@core/constants';
import { PosConfirmationService } from 'src/app/@core/services/pos-confirmation.service';
import { GiftCard } from 'src/app/models/giftcard';
import { Invoice } from 'src/app/models/invoice';
import { Order } from 'src/app/models/order';
import { GiftcardRequest } from 'src/app/models/request/giftcard-request';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { GiftCardService } from 'src/app/services/giftcard.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-giftcard-create-return',
  templateUrl: './giftcard-create-return.component.html',
  styleUrls: ['./giftcard-create-return.component.sass']
})
export class GiftcardCreateReturnComponent implements OnInit {

  giftCard: GiftCard = new GiftCard();
  order: Order = new Order();
  invoice: Invoice = new Invoice();
  constructor(private giftcardService: GiftCardService, private route: ActivatedRoute, private invoiceService: InvoiceService, private configService: ConfigurationService, private confirmService: PosConfirmationService, private router: Router, private toastr: ToastrService) { }

  async ngOnInit(): Promise<void> {
    this.giftCard = (await this.giftcardService.readGiftCard(this.route.snapshot.params.code).toPromise()).response;
    this.invoice = (await this.invoiceService.readInvoices({ page: 0, pageSize: 1, value: { code: this.giftCard.invoiceCode } }).toPromise()).response.content[0];
    this.order = await this.simulateOrder();
    // this.order = (await this.orderService.simulateOrderWithLoans)
  }
  async simulateOrder(): Promise<Order> {

    const request = new GiftcardRequest();
    request.customerCode = this.invoice.customerCode;
    request.paymentsRequestModel.branchCode = this.configService.readSelectedBranchAndSalesOrg().branch.code;
    request.paymentsRequestModel.salesOrgCode = this.configService.readSelectedBranchAndSalesOrg().salesOrg.code;
    request.paymentsRequestModel.registerCode = this.configService.readRegister().code;
    return (await this.giftcardService.simulateDummyOrder(this.giftCard.giftCardNumber, request).toPromise()).response;
  }

  async return(type: ReturnPaymentType) {

    await this.confirmService.show("¡Advertencia!", `¿Está seguro de querer devolver la giftcard ${this.giftCard.giftCardNumber}`, ModalDialogType.WARNING, async () => {
      const request = new GiftcardRequest();
      request.customerCode = this.invoice.customerCode;
      request.paymentsRequestModel.branchCode = this.configService.readSelectedBranchAndSalesOrg().branch.code;
      request.paymentsRequestModel.salesOrgCode = this.configService.readSelectedBranchAndSalesOrg().salesOrg.code;
      request.paymentsRequestModel.registerCode = this.configService.readRegister().code;
      request.returnPaymentMethod = type == ReturnPaymentType.CASH ? "ZE01" : type == ReturnPaymentType.CREDIT_NOTE ? "ZN02" : "";

      const response = (await this.giftcardService.createRefundGiftcard(this.giftCard.giftCardNumber, request).toPromise()).response;

      if (response.creditNoteNumber) {
        Swal.fire({
          title: `Giftcards`,
          html: `Se ha devuelto la giftcard ${this.giftCard.giftCardNumber}`,
          icon: 'success',
          confirmButtonText: 'Aceptar',
        });
        this.router.navigate(["giftcards", response.giftCardNumber], {
          queryParams: {
            printReturn: true
          }
        });
      }
    });
  }
}

